export type Permissions = AdminPermissions | ClientPermissions;

export enum AdminPermissions {
	GlobalAdmin = "GlobalAdmin",

	ViewOrganization = "ViewOrganization",

	EditOrganization = "EditOrganization",

	ViewOrganizationLocation = "ViewOrganizationLocation",

	EditOrganizationLocation = "EditOrganizationLocation",

	ViewOrganizationRole = "ViewOrganizationRole",

	EditOrganizationRole = "EditOrganizationRole",

	ViewOrganizationReportSetting = "ViewOrganizationReportSetting",

	EditOrganizationReportSetting = "EditOrganizationReportSetting",

	ViewOrganizationCustomField = "ViewOrganizationCustomField",

	EditOrganizationCustomField = "EditOrganizationCustomField",

	ViewOrganizationFleetError = "ViewOrganizationFleetError",

	EditOrganizationFleetError = "EditOrganizationFleetError",

	ViewOrganizationUser = "ViewOrganizationUser",

	EditOrganizationUser = "EditOrganizationUser",

	ViewDataset = "ViewDataset",

	EditDataset = "EditDataset",

	ViewDatasetLocation = "ViewDatasetLocation",

	EditDatasetLocation = "EditDatasetLocation",

	ViewDatasetReportSetting = "ViewDatasetReportSetting",

	EditDatasetReportSetting = "EditDatasetReportSetting",

	ViewDatasetCutpoints = "ViewDatasetCutpoints",

	EditDatasetCutpoints = "EditDatasetCutpoints",

	ViewDatasetUser = "ViewDatasetUser",

	EditDatasetUser = "EditDatasetUser",

	ViewReport = "ViewReport",

	EditReport = "EditReport",

	ViewTemplate = "ViewTemplate",

	EditTemplate = "EditTemplate",
}

// Dataset Permissions

export enum ClientPermissions {
	ViewClient = "ViewClient",

	EditClient = "EditClient",

	ViewCoreTest = "ViewCoreTest",

	EditCoreTest = "EditCoreTest",

	ViewVitalsTest = "ViewVitalsTest",

	EditVitalsTest = "EditVitalsTest",

	ViewCareTest = "ViewCareTest",

	EditCareTest = "EditCareTest",

	ViewOwnResults = "ViewOwnResults",

	ViewAllResults = "ViewAllResults",

	NeurapulseAdmin = "NeurapulseAdmin",
}
